<template>
  <div>
    <datatable
      ref="eventsTable"
      id="eventsTable"
      :filter="eventsSearch"
      :flat="true"
      :data="eventsList"
      :columns="eventColumns"
      :disableSearchCols="['playerLabels']"
      :vScroll="false"
      @rowDoubleClick="eventDoubleClick"
    >
      <template slot="body-cell-event_no" slot-scope="data">
        <q-td :props="data.props">
          <q-input
            label=""
            v-model="data.props.row.event_no"
            dense
            @blur="saveEventFromGrid(data.props.row)"
          ></q-input>
        </q-td>
      </template>
      <template slot="body-cell-event_name" slot-scope="data">
        <q-td :props="data.props">
          <b>{{ data.props.row.event_name }}</b>
          <br />

          <span style="color: gray; font-size: 8pt">
            {{ data.props.row.division_name }} / {{ data.props.row.gender }}
            {{ data.props.row.age_min }}-{{ data.props.row.age_max }}yrs
          </span>
        </q-td>
      </template>
      <template slot="body-cell-playerLabels" slot-scope="data">
        <q-td :props="data.props">
          <q-icon name="mdi-file-certificate-outline" size="sm"></q-icon>
          <q-tooltip>
            <div>Player Labels</div>
            <div
              v-for="(label, index) in JSON.parse(data.props.row.playerLabels)"
              :key="`label_${index}`"
            >
              {{ label.name }} -
              {{ label.twoHundredMeter == 1 ? "200m Badge," : "" }}
              {{ label.patrolSupport == 1 ? "PS or SLG," : "" }}
              {{ label.slg == 1 ? "SLG Award," : "" }}
              {{ label.crew == 1 ? "IRB Crew," : "" }}
              {{ label.driver == 1 ? "IRB Driver," : "" }}
              {{ label.mixed == 1 ? "Mixed Gender," : "" }}
              {{ label.noMaxAge == 1 ? "Open Age," : "" }}
              {{ label.required == 1 ? "Required" : "" }}
            </div>
          </q-tooltip>
        </q-td>
      </template>
      <template slot="body-cell-entriesOpenOverride" slot-scope="data">
        <q-td :props="data.props">
          <q-icon
            :name="
              `mdi-${
                data.props.row.entriesOpenOverride ||
                (entriesOpen && data.props.row.currentStep == 0)
                  ? 'check-circle-outline'
                  : 'close-circle-outline'
              }`
            "
            :color="
              data.props.row.entriesOpenOverride ||
              (entriesOpen && data.props.row.currentStep == 0)
                ? 'positive'
                : 'negative'
            "
            size="sm"
          >
            <q-tooltip>
              Entries are
              {{
                data.props.row.entriesOpenOverride ||
                (entriesOpen && data.props.row.currentStep == 0)
                  ? "Open"
                  : "Closed"
              }}
            </q-tooltip>
          </q-icon>
        </q-td>
      </template>
      <template slot="body-cell-sessions_id" slot-scope="data">
        <q-td :props="data.props">
          {{
            data.props.row.sessions_id
              ? sessionsDict[data.props.row.sessions_id]
              : "Not Selected"
          }}
          <q-menu auto-close>
            <div
              style="min-width: 200px; width: 200px"
              v-for="(session, index) in sessions"
              :key="`session_${index}`"
              @click="updateEventSession(data.props.row, session.id)"
              class="cursor-pointer sesarenaMenu"
            >
              <div class="q-pa-sm">
                {{ session.name }}
              </div>
            </div>
          </q-menu>
          <!-- <q-select
            v-model="data.props.row.sessions_id"
            label="Session"
            v-bind="siteCFG.fields.general"
            :options="sessions"
            :loading="sessionsLoading"
            option-label="name"
            option-value="id"
            emit-value
            map-options
            dense
            @input="updateEventSession(data.props.row)"
          >
          </q-select> -->
        </q-td>
      </template>
      <template slot="body-cell-arenas_id" slot-scope="data">
        <q-td :props="data.props">
          {{
            data.props.row.arenas_id
              ? arenasDict[data.props.row.arenas_id]
              : "Not Selected"
          }}
          <q-menu auto-close>
            <div
              style="min-width: 200px; width: 200px"
              v-for="(arena, index) in arenas"
              :key="`arena_${index}`"
              @click="updateEventArena(data.props.row, arena.id)"
              class="cursor-pointer sesarenaMenu"
            >
              <div class="q-pa-sm">
                {{ arena.name }}
              </div>
            </div>
          </q-menu>
          <!-- <q-select
            v-model="data.props.row.arenas_id"
            label="Arena"
            v-bind="siteCFG.fields.general"
            :options="arenas"
            :loading="arenasLoading"
            option-label="name"
            option-value="id"
            emit-value
            map-options
            dense
            @input="updateEventArena(data.props.row)"
          >
          </q-select> -->
        </q-td>
      </template>

      <template slot="body-cell-actions" slot-scope="data">
        <q-td :props="data.props">
          <q-btn
            :loading="duplicatingEventID == data.props.row.id"
            @click="duplicateEvent(data.props.row.id)"
            round
            flat
          >
            <q-icon name="mdi-content-copy"></q-icon>
            <q-tooltip>Duplicate</q-tooltip>
          </q-btn>
          <q-btn
            :loading="removingEventID == data.props.row.id"
            @click="removeEvent(data.props.row.id)"
            round
            flat
            color="negative"
          >
            <q-icon name="mdi-trash-can-outline"></q-icon>
            <q-tooltip>Remove Event</q-tooltip>
          </q-btn>
          <q-btn dense round flat class="float-right" color="black">
            <q-icon name="mdi-dots-vertical"></q-icon>
            <q-menu>
              <q-list style="min-width: 100px">
                <q-item
                  @click="openEntries(data.props.row)"
                  clickable
                  v-close-popup
                >
                  <q-item-section>
                    {{
                      !data.props.row.entriesOpenOverride
                        ? "Keep Entries Open"
                        : "Revert to Competition Entries Dates"
                    }}
                  </q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </q-btn>
        </q-td>
      </template>
    </datatable>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Sortable from "sortablejs";
import { moveItemInArray } from "@/plugins/move";
import datatable from "@/components/datatable/datatable.vue";
// import tiptap from "@/components/tiptap/tiptap.vue";
import moment from "moment";
import api from "@/api.js";

export default {
  components: {
    datatable
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      siteCFG: "settings/siteCFG",
      data: "competitions/current",
      dataLoading: "competitions/currentLoading",
      divisions: "divisions/list",
      divisionsLoading: "divisions/listLoading",
      events: "events/listForCompetition",
      eventsLoading: "events/listForCompetitionLoading",
      sessions: "sessions/listForCompetition",
      sessionsLoading: "sessions/listForCompetitionLoading",
      sessionsDict: "sessions/listDictionaryForCompetition",
      arenas: "arenas/listForCompetition",
      arenasLoading: "arenas/listForCompetitionLoading",
      arenasDict: "arenas/listDictionaryForCompetition"
    }),
    entriesOpen: function() {
      return moment(this.data.entriesCloseDate) > moment();
    }
  },
  props: {
    id: {
      default: null
    },
    eventsSearch: {
      default: ""
    }
  },
  watch: {
    events: function() {
      this.sortEventsList();
    }
  },
  data: () => ({
    // Events
    eventColumns: [
      {
        name: "drag-handle",
        align: "left"
      },
      {
        name: "event_no",
        label: "#",
        align: "left",
        field: "event_no",
        style:
          "min-width: 30px;max-width: 30px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "event_name",
        label: "Event/Division",
        align: "left",
        field: "event_name",
        style:
          "min-width: 300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

        sortable: true
      },
      {
        name: "team_size_max",
        label: "Team Size",
        align: "left",
        field: "team_size_max",
        format: (val, row) => {
          if (row.playerLabels) {
            return JSON.parse(row.playerLabels).length;
          } else {
            return 0;
          }
        },
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

        sortable: true
      },
      {
        name: "Fee",
        label: "Fee / Penalty",
        align: "left",
        field: "fee",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "sessions_id",
        label: "Session",
        align: "left",
        field: "sessions_id",
        style:
          "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "arenas_id",
        label: "Arena",
        align: "left",
        field: "arenas_id",
        style:
          "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "playerLabels",
        label: "Player Labels",
        align: "left",
        field: "playerLabels",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "entriesOpenOverride",
        label: "Entries Open",
        align: "left",
        field: "entriesOpenOverride",
        style:
          "min-width: 80px;max-width: 80px;width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "actions",
        label: "Actions",
        align: "left",
        sortable: false
      }
    ],
    addEvent: false,
    addEventLoading: false,
    removingEventID: null,
    duplicatingEventID: null,
    editEvent: false,
    editEventLoading: false,
    eventsList: [],
    sortable: Sortable
  }),
  beforeCreate() {},
  mounted() {
    this.sortEventsList();
    const tableBody = document.querySelector("#eventsTable tbody");

    const self = this;

    this.sortable = Sortable.create(tableBody, {
      draggable: "tr",
      animation: 250,
      onEnd(evt) {
        if (evt.oldIndex === evt.newIndex) {
          return;
        }

        // Remove the item from its old index
        const [removed] = self.eventsList.splice(evt.oldIndex, 1);

        // Insert the item at its new index
        self.eventsList.splice(evt.newIndex, 0, removed);

        self.generateEventsNumbers();
      }
    });
  },
  destroyed() {
    this.sortable.destroy();
  },
  methods: {
    // Events
    submitEventToAdd() {
      this.$refs.addEventForm.addEventToCompetition(this.data.id);
    },
    saveEvent() {
      this.$refs.editEventForm.save();
    },
    saveEventFromGrid(data) {
      this.$store.dispatch("events/save", data).then(result => {
        if (result.Result == "Success") {
          this.address = "";
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later"
          });
        }
      });
    },
    eventDoubleClick(row) {
      this.$router.push(`/competitions/${this.data.id}/events/${row.id}`);
    },
    removeEvent(id) {
      this.removingEventID = id;
      this.$store
        .dispatch("events/removeFromCompetition", {
          id: id,
          competitions_id: this.data.id
        })
        .then(result => {
          if (result.Result == "Success") {
            this.address = "";
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    duplicateEvent(id) {
      this.duplicatingEventID = id;
      this.$store
        .dispatch("events/duplicateEvent", {
          id: id,
          competitions_id: this.data.id
        })
        .then(result => {
          this.duplicatingEventID = null;
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    sortEventsList() {
      this.eventsList = JSON.parse(JSON.stringify(this.events))
        .sort((a, b) =>
          a.event_name > b.event_name ? 1 : b.event_name > a.event_name ? -1 : 0
        )
        // Numeric compare — event_no can come back from the API as a string,
        // and "10" < "2" lexicographically scrambles the saved order
        .sort((a, b) => (Number(a.event_no) || 0) - (Number(b.event_no) || 0));
    },
    generateEventsNumbers() {
      this.eventsList.forEach((event, index) => {
        event.event_no = index + 1;
      });

      // Loop over all of the events, get the ID and new index as objects and send to the API
      const events = [];
      this.eventsList.forEach(event => {
        events.push({
          id: event.id,
          event_no: event.event_no
        });
      });

      this.$store.dispatch("events/updateEventNumbers", events).then(result => {
        if (result.Result != "Success") {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message:
              "The event order could not be saved, Please try again later"
          });
        }
      });
    },
    async openEntries(data) {
      try {
        let result = await this.$store.dispatch("events/save", {
          id: data.id,
          competitions_id: this.data.id,
          entriesOpenOverride: data.entriesOpenOverride ? 0 : 1
        });
        this.$q.notify({
          position: "top-right",
          type: result.Result == "Success" ? "positive" : "negative",
          message:
            result.Result == "Success"
              ? result.Response.Message
              : "There was an error, Please try again later"
        });
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error, Please try again later"
        });
      }
    },
    async updateEventSession(row, id) {
      try {
        row.sessions_id = id;
        let result = await this.$store.dispatch("events/save", {
          id: row.id,
          competitions_id: this.data.id,
          sessions_id: row.sessions_id
        });
        this.$q.notify({
          position: "top-right",
          type: result.Result == "Success" ? "positive" : "negative",
          message:
            result.Result == "Success"
              ? result.Response.Message
              : "There was an error, Please try again later"
        });
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error, Please try again later"
        });
      }
    },
    async updateEventArena(row, id) {
      try {
        row.arenas_id = id;
        let result = await this.$store.dispatch("events/save", {
          id: row.id,
          competitions_id: this.data.id,
          arenas_id: row.arenas_id
        });
        this.$q.notify({
          position: "top-right",
          type: result.Result == "Success" ? "positive" : "negative",
          message:
            result.Result == "Success"
              ? result.Response.Message
              : "There was an error, Please try again later"
        });
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error, Please try again later"
        });
      }
    }
  }
};
</script>

<style>
.sesarenaMenu {
  cursor: pointer;
  width: 200px;
  min-width: 200px;
}

.sesarenaMenu :hover {
  background-color: #f2f2f2;
}
</style>
